export const loadDefaultProject = (): void => {
  const sp = new URLSearchParams(document.location.search)
  sp.delete('configId')
  sp.delete('configHashKey')
  document.location.search = sp.toString()
}
